<!--纯列表界面-->
<template>
	<ul class="list-body custom-scrollbar">
		<li v-for="item in dataList" @click="nowItem = item, $emit('checkItem',nowItem)" :class="{isCheck:nowItem == item}">
			<slot :item="item">
				<p v-if="item.type == 'tips'" style="text-align: center;">{{item[nameKey]}}</p>
				<p v-else :title="item[nameKey]">{{item[nameKey]}}</p>
			</slot>
		</li>
	</ul>
</template>

<script>
	export default {
		components: {},
		props: {
			dataList: {
				type: Array,
				default () {
					return []
				}
			},
			nameKey: {
				type: String,
				default: 'name'
			},
			autoCheckIndex: {
				type: Number,
			}
		},
		data() {
			return {
				nowItem: undefined
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {},
		watch: {
			dataList(nv, ov) {
				if (nv != undefined && this.autoCheckIndex != undefined) {
					this.nowItem = nv[this.autoCheckIndex]
					this.$emit('checkItem',this.nowItem)
				}
			}
		},
		methods: {
			setNowItem(item) {
				this.nowItem = item
				this.$emit('checkItem', item)
			}
		}
	}
</script>

<style scoped>
</style>
